"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RoadComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactQuery = require("react-query");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _request = require("@nicbase/request");

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

var _nicbaseDialogs = require("nicbase-dialogs");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

var _constants = require("../constants");

var _informationStep = _interopRequireDefault(require("./information-step"));

var _monitoringStep = _interopRequireDefault(require("./monitoring-step"));

var _procedureStep = _interopRequireDefault(require("./procedure-step"));

var _segmentStep = _interopRequireDefault(require("./segment-step"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var deleteRoute = function deleteRoute(portalId, id) {
  return {
    type: 'DELETE_ROUTE_REQUEST',
    headers: {
      version: 'v2',
      portalId: portalId
    },
    body: {
      id: id
    }
  };
};

var RoadComponent = function RoadComponent(_ref) {
  var _tour$route$id, _tour$route;

  var hasPermissions = _ref.hasPermissions,
      portalId = _ref.portalId,
      isActive = _ref.isActive,
      isNewTour = _ref.isNewTour,
      onSave = _ref.onSave,
      onUpdate = _ref.onUpdate,
      onCancel = _ref.onCancel,
      tour = _ref.tour,
      isShareTour = _ref.isShareTour,
      alarms = _ref.alarms,
      assets = _ref.assets,
      linkedPortals = _ref.linkedPortals;

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      selectedSegment = _useState2[0],
      setSelectedSegment = _useState2[1];

  var _useState3 = (0, _react.useState)({
    id: (_tour$route$id = tour === null || tour === void 0 ? void 0 : (_tour$route = tour.route) === null || _tour$route === void 0 ? void 0 : _tour$route.id) !== null && _tour$route$id !== void 0 ? _tour$route$id : null
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      tourRoute = _useState4[0],
      setTourRoute = _useState4[1]; // request to save the route of the tour


  var _usePortalSaveRoute = (0, _hooks.usePortalSaveRoute)({
    portalId: portalId
  }),
      saveRouteRequest = _usePortalSaveRoute.mutateAsync; // request to delete the route of the tour


  var _useMutation = (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(routeId) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", request(deleteRoute(portalId, routeId)));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()),
      deleteRouteRequest = _useMutation.mutateAsync; // request to load system exchange projects


  var _usePortalSystemExcha = (0, _hooks.usePortalSystemExchangeProjects)(portalId),
      systemExchangeProjects = _usePortalSystemExcha.data;

  var tourSchema = (0, _yup.object)().shape({
    name: (0, _yup.string)().min(1).max(64).required(),
    dataRequest: (0, _yup.object)().shape({
      haulerEmail: (0, _yup.string)().email().nullable()
    }).nullable(),
    wayPoints: (0, _yup.array)().of((0, _yup.object)().shape({
      poiId: (0, _yup.number)().min(1).required(),
      frontendId: (0, _yup.string)().test({
        message: function message(msg) {
          return msg.value;
        },
        test: function test(value) {
          // if error with poi id then return the frontend id for the correct assignment in form
          if (this.parent.poiId) {
            return value;
          }

          return null;
        }
      })
    })),
    earliestStartTime: (0, _yup.date)().min(new Date()).nullable(),
    scheduledStartTime: (0, _yup.date)().min(new Date()).nullable(),
    scheduledEndTime: (0, _yup.date)().min(new Date()).nullable()
  });
  var schema = (0, _yup.object)().shape({
    tour: tourSchema
  });
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentStep = _useState6[0],
      setCurrentStep = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      hasVisitedSegments = _useState8[0],
      setHasVisitedSegments = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      monitoringStepIsValid = _useState10[0],
      setMonitoringStepIsValid = _useState10[1];

  var saveButtonLabel;
  var dialogTitle;

  if (isNewTour) {
    saveButtonLabel = 'widgets.tourBoard.createTour';
    dialogTitle = 'tourBoard.newTour.title';
  } else {
    saveButtonLabel = 'widgets.tourBoard.editTour';
    dialogTitle = 'tourBoard.editTour.title';
  } // formik validation


  var _useFormik = (0, _formik.useFormik)({
    initialValues: {
      tour: tour
    },
    validateOnMount: true,
    validationSchema: schema,
    onSubmit: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3) {
        var _updatedTour$route, _tour$route2, _updatedTour$route2;

        var updatedTour;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                updatedTour = _ref3.tour;

                if (!(tourRoute !== null && tourRoute !== void 0 && tourRoute.id && tourRoute !== null && tourRoute !== void 0 && tourRoute.geometry && (_updatedTour$route = updatedTour.route) !== null && _updatedTour$route !== void 0 && _updatedTour$route.id)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return saveRouteRequest(tourRoute);

              case 4:
                _context2.next = 9;
                break;

              case 6:
                if (!((_tour$route2 = tour.route) !== null && _tour$route2 !== void 0 && _tour$route2.id && !((_updatedTour$route2 = updatedTour.route) !== null && _updatedTour$route2 !== void 0 && _updatedTour$route2.id))) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 9;
                return deleteRouteRequest(tour.route.id);

              case 9:
                if (isNewTour) {
                  onSave(updatedTour);
                } else {
                  onUpdate(updatedTour);
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onSubmit(_x2) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  }),
      handleSubmit = _useFormik.handleSubmit,
      fields = _useFormik.values,
      errors = _useFormik.errors,
      setFieldValue = _useFormik.setFieldValue,
      _useFormik$isValid = _useFormik.isValid,
      isValid = _useFormik$isValid === void 0 ? false : _useFormik$isValid,
      touched = _useFormik.touched,
      setFieldTouched = _useFormik.setFieldTouched;

  var onTourMerge = (0, _react.useCallback)(function (values) {
    var _Object$entries = Object.entries(values),
        _Object$entries2 = _slicedToArray(_Object$entries, 1),
        _Object$entries2$ = _slicedToArray(_Object$entries2[0], 2),
        key = _Object$entries2$[0],
        value = _Object$entries2$[1];

    setFieldTouched("tour.".concat(key));
    setFieldValue("tour.".concat(key), value);
  }, [setFieldTouched, setFieldValue]); // check if the last step was the segment step

  var previousStep = (0, _hooks.usePrevious)(currentStep);
  (0, _hooks.useDidUpdate)(function () {
    if (previousStep !== currentStep && previousStep === 2) {
      setHasVisitedSegments(true);
      setFieldValue('tour.segments', fields.tour.segments.filter(function (segment) {
        return segment.validityWayPointIndexRange.length > 1;
      }));
    }
  }, [currentStep, fields.tour.segments, previousStep, setFieldValue]); // set monitoring step to valid if one input is changed

  var monitoringValues = (0, _react.useMemo)(function () {
    return {
      route: fields.tour.route,
      startStopAlarmsEnabled: fields.tour.startStopAlarmsEnabled,
      etaAlarmsEnabled: fields.tour.etaAlarmsEnabled,
      alarms: fields.tour.alarms,
      report: fields.tour.report
    };
  }, [fields.tour.alarms, fields.tour.etaAlarmsEnabled, fields.tour.report, fields.tour.route, fields.tour.startStopAlarmsEnabled]);
  var prevMonitoringValues = (0, _hooks.usePrevious)(monitoringValues);
  (0, _hooks.useDidUpdate)(function () {
    if (!monitoringStepIsValid && monitoringValues !== prevMonitoringValues) {
      setMonitoringStepIsValid(true);
    }
  }, [monitoringStepIsValid, monitoringValues, prevMonitoringValues]);
  var tourIsValid = tour.status !== _constants.TOUR_STATUS.RUNNING && tour.status !== _constants.TOUR_STATUS.FINISHED && isValid;
  var steps = (0, _react.useMemo)(function () {
    var _errors$tour, _errors$tour2, _errors$tour3, _errors$tour4, _errors$tour5, _fields$tour$segments, _fields$tour$segments2;

    return [{
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-1 justify-center items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_informationStep["default"], {
        projects: systemExchangeProjects,
        tour: fields.tour,
        isShareTour: isShareTour,
        assets: assets,
        linkedPortals: linkedPortals,
        onUpdate: onTourMerge,
        errors: errors.tour,
        touched: touched.tour
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.road.createTour.information'
      }),
      inputsAreValid: !((_errors$tour = errors.tour) !== null && _errors$tour !== void 0 && _errors$tour.name),
      saveButtonAction: function saveButtonAction() {
        return setCurrentStep(function (prevStep) {
          return prevStep + 1;
        });
      },
      saveButtonLabelId: 'common.nextStep'
    }, {
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-1 flex-col justify-center items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_procedureStep["default"], {
        tour: fields.tour,
        onUpdate: onTourMerge,
        errors: errors.tour,
        touched: touched.tour
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.road.createTour.procedure'
      }),
      inputsAreValid: !((_errors$tour2 = errors.tour) !== null && _errors$tour2 !== void 0 && _errors$tour2.wayPoints) && !((_errors$tour3 = errors.tour) !== null && _errors$tour3 !== void 0 && _errors$tour3.earliestStartTime) && !((_errors$tour4 = errors.tour) !== null && _errors$tour4 !== void 0 && _errors$tour4.scheduledStartTime) && !((_errors$tour5 = errors.tour) !== null && _errors$tour5 !== void 0 && _errors$tour5.scheduledEndTime),
      saveButtonAction: function saveButtonAction() {
        return setCurrentStep(function (prevStep) {
          return prevStep + 1;
        });
      },
      saveButtonLabelId: 'common.nextStep'
    }, {
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-1 flex-col pl-12 pr-2 py-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_segmentStep["default"], {
        key: fields.tour.segments,
        projects: systemExchangeProjects,
        alarms: alarms,
        tour: fields.tour,
        onUpdate: onTourMerge,
        onSelectedSegment: setSelectedSegment,
        selectedSegment: selectedSegment
      })),
      title: /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-col"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        onClick: function onClick() {
          return setSelectedSegment(null);
        }
      }, intl.formatMessage({
        id: 'widgets.tourBoard.road.createTour.segments'
      })), (_fields$tour$segments = fields.tour.segments) === null || _fields$tour$segments === void 0 ? void 0 : _fields$tour$segments.map(function (segment, index) {
        var isValidSegment = segment.validityWayPointIndexRange.length > 1;
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: (0, _classnames["default"])('text-sm ml-4 mt-2 font-normal', {
            'font-bold': index === selectedSegment,
            'text-gray-500': !isValidSegment
          }),
          onClick: function onClick() {
            return isValidSegment && setSelectedSegment(index);
          }
        }, "Segment ", index + 1);
      })),
      inputsAreValid: hasVisitedSegments || ((_fields$tour$segments2 = fields.tour.segments) === null || _fields$tour$segments2 === void 0 ? void 0 : _fields$tour$segments2.length) > 0,
      saveButtonAction: function saveButtonAction() {
        return setCurrentStep(function (prevStep) {
          return prevStep + 1;
        });
      },
      saveButtonLabelId: 'common.nextStep'
    }, {
      stepComponent: /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-1 flex-col justify-center items-center p-8 overflow-y-auto"
      }, /*#__PURE__*/_react["default"].createElement(_monitoringStep["default"], {
        tour: fields.tour,
        onUpdate: onTourMerge,
        alarms: alarms,
        setTourRoute: setTourRoute,
        tourRoute: tourRoute
      })),
      title: intl.formatMessage({
        id: 'widgets.tourBoard.road.createTour.monitoring'
      }),
      inputsAreValid: monitoringStepIsValid,
      saveButtonAction: function saveButtonAction() {
        handleSubmit();
      },
      saveButtonLabelId: saveButtonLabel
    }].filter(function (step, index) {
      if (!hasPermissions(['module.tour.segments'])) {
        return index !== 2;
      }

      return step;
    });
  }, [systemExchangeProjects, fields.tour, isShareTour, assets, linkedPortals, onTourMerge, errors.tour, touched.tour, intl, alarms, selectedSegment, hasVisitedSegments, tourRoute, monitoringStepIsValid, saveButtonLabel, handleSubmit, hasPermissions]);

  var onDisableCurrentStep = function onDisableCurrentStep() {
    if (currentStep === 0) {
      var _errors$tour6;

      return !!((_errors$tour6 = errors.tour) !== null && _errors$tour6 !== void 0 && _errors$tour6.name);
    }

    if (currentStep === 1) {
      var _errors$tour7, _errors$tour8, _errors$tour9, _errors$tour10;

      return !!((_errors$tour7 = errors.tour) !== null && _errors$tour7 !== void 0 && _errors$tour7.wayPoints) || !!((_errors$tour8 = errors.tour) !== null && _errors$tour8 !== void 0 && _errors$tour8.earliestStartTime) || !!((_errors$tour9 = errors.tour) !== null && _errors$tour9 !== void 0 && _errors$tour9.scheduledStartTime) || !!((_errors$tour10 = errors.tour) !== null && _errors$tour10 !== void 0 && _errors$tour10.scheduledEndTime);
    }

    if (currentStep === 2) {
      return false;
    }

    if (currentStep === steps.length - 1) {
      return !tourIsValid;
    }

    return false;
  };

  return /*#__PURE__*/_react["default"].createElement(_nicbaseDialogs.BasisDialog, {
    className: _indexModule["default"].createTourDialog,
    active: isActive,
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: dialogTitle
    }),
    content: /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Steps, {
      className: _indexModule["default"].createTourContent,
      barClassName: "min-w-64 overflow-y-auto",
      currentStep: currentStep,
      onCurrentStepChange: setCurrentStep,
      steps: steps
    }),
    actions: [/*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      key: "road-tour-dialog-button-cancel",
      primary: true,
      onClick: onCancel,
      className: "mr-3"
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.cancel"
    })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Button, {
      key: "road-tour-dialog-button-save",
      primary: true,
      raised: true,
      onClick: steps[currentStep].saveButtonAction,
      disabled: onDisableCurrentStep()
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: steps[currentStep].saveButtonLabelId
    }))]
  });
};

exports.RoadComponent = RoadComponent;

var noop = function noop() {};

RoadComponent.propTypes = {
  hasPermissions: _propTypes["default"].func.isRequired,
  portalId: _propTypes["default"].number.isRequired,
  isActive: _propTypes["default"].bool.isRequired,
  isNewTour: _propTypes["default"].bool.isRequired,
  isShareTour: _propTypes["default"].bool,
  onSave: _propTypes["default"].func,
  onUpdate: _propTypes["default"].func,
  onCancel: _propTypes["default"].func,
  tour: _propTypes["default"].shape({
    route: _propTypes["default"].shape({
      id: _yup.string
    }),
    wayPoints: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
    status: _propTypes["default"].string,
    segments: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      validityWayPointIndexRange: _propTypes["default"].arrayOf(_propTypes["default"].number),
      projects: _propTypes["default"].arrayOf(_propTypes["default"].string),
      alarms: _propTypes["default"].arrayOf(_propTypes["default"].number)
    }))
  }),
  alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  assets: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  linkedPortals: _propTypes["default"].shape({})
};
RoadComponent.defaultProps = {
  isShareTour: false,
  tour: {
    alarms: []
  },
  alarms: [],
  assets: [],
  linkedPortals: {},
  onSave: noop,
  onUpdate: noop,
  onCancel: noop
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.road'])(RoadComponent);

exports["default"] = _default;